export default __webpack_public_path__ + "static/media/photo01_pc.f2767ad4.jpg";